import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledFormSection = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const StyledFormSectionTitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
});

export const StyledFormSectionHeader = styled(Box)({
  fontSize: "18px",
  fontWeight: 700,
  gridColumn: "span 2",
});

export const StyledFormGridContainer = styled(Box)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "30px",
});
